<template>
  <!-- 决算阶段 -->
    <div class="bid-box">
        <el-form ref="form" :model="form" label-width="300px">
            <el-form-item label="所属合同：">
                <span style="color:#296dd3;">{{agreeName}}</span>
            </el-form-item>
            <el-form-item label="初审决算价款及报告：">
                <el-checkbox  v-if="edit" v-model="final.firstAccountinfo.flag">无</el-checkbox>
                <el-checkbox v-else v-model="final.firstAccountinfo.flag" disabled>无</el-checkbox>
                <div v-if="!final.firstAccountinfo.flag">
                    <div v-for="(item,index) in final.firstAccountinfo.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex='-1'" @mouseenter="delIndex=index">
                        <el-date-picker
                            v-if="edit"
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                        <el-date-picker
                            v-else
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            disabled
                            >
                        </el-date-picker>
                        <span style="margin-left:1vw;">送审价款：</span>
                        <el-input v-if="edit" v-model="item.start" placeholder="" style="width:5vw;" @blur="setFirstTotal"></el-input>
                        <el-input v-else v-model="item.start" placeholder="" style="width:5vw;" @blur="setFirstTotal" disabled></el-input>
                        <span  style="margin-right:2vw;padding-left:5px;">万元</span>

                        <el-date-picker
                            v-if="edit" 
                            v-model="item.endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                         <el-date-picker
                            v-else
                            v-model="item.endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            disabled
                            >
                        </el-date-picker>
                        <span style="margin-left:1vw;">初审价款：	</span>
                        <el-input v-if="edit"  v-model="item.end" placeholder="" style="width:5vw;" @blur="setFirstTotal"></el-input>
                         <el-input v-else v-model="item.end" placeholder="" style="width:5vw;" @blur="setFirstTotal" disabled></el-input>
                        <span style="margin-right:2vw;padding-left:5px;">万元</span>
                        <el-upload
                            class="upload-demo len100"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess"
                            :on-remove="handleDel"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                        </el-upload>
                        <!-- <el-button size="small" type="primary" v-if="!edit">暂无</el-button> -->
                        <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toFirstAccount" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit" v-show="delIndex==index" class="el-icon-delete ctl" @click="delFirstAccount(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="总价：">
                <p style="width:75%;display:flex;justify-content: space-around;color:#296dd3;">
                    <span style="color:#296dd3;">送审价款:	{{final.firstAll.start}}万元</span>
                    <span style="color:#296dd3;">初审价款:	{{final.firstAll.end}}万元</span>
                </p>
            </el-form-item>
            <el-form-item label="终审决算价款及报告：">
                <!-- <el-checkbox v-model="final.finalAccountinfo.flag">无</el-checkbox> -->
                <div>
                    <div v-for="(item,index) in final.finalAccountinfo.list" :key="index" style="display:flex;;" :style="index!=1?'margin-top:2vh':''" @mouseleave="delIndex1='-1'" @mouseenter="delIndex1=index">
                        <el-date-picker
                            v-if="edit"
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                         <el-date-picker
                            v-else
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            disabled
                            >
                        </el-date-picker>
                        <span style="margin-left:1vw;">送审价款：</span>
                        <el-input v-if="edit" v-model="item.start" placeholder="" style="width:5vw;" @blur="setFinalTotal"></el-input>
                        <el-input v-else  v-model="item.start" placeholder="" style="width:5vw;" @blur="setFinalTotal" disabled></el-input>
                        <span style="margin-right:2vw;padding-left:5px;">万元</span>

                        <el-date-picker
                            v-if="edit"
                            v-model="item.endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                        <el-date-picker
                            v-else
                            v-model="item.endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            disabled
                            >
                        </el-date-picker>
                        <span style="margin-left:1vw;">终审价款：	</span>
                        <el-input v-if="edit"  v-model="item.end" placeholder="" style="width:5vw;" @blur="setFinalTotal"></el-input>
                        <el-input v-else v-model="item.end" placeholder="" style="width:5vw;" @blur="setFinalTotal" disabled></el-input>
                        <span style="margin-right:2vw;padding-left:5px;">万元</span>
                        <el-upload
                            class="upload-demo len100"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess1"
                            :on-remove="handleDel1"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button  v-if="edit"  size="small" type="primary">点击上传</el-button>
                        </el-upload>
                        <!-- <el-button  v-if="!edit"  size="small" type="primary">暂无</el-button> -->
                        <i v-if="edit"  class="el-icon-circle-plus-outline ctl" @click="toFinalAccount" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit"  v-show="delIndex1==index" class="el-icon-delete ctl" @click="delFinalAccount(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="总价：">
                <p style="width:75%;display:flex;justify-content: space-around;color:#296dd3;">
                    <span style="color:#296dd3;">送审价款:	{{final.finalAll.start}}万元</span>
                    <span style="color:#296dd3;">终审价款:	{{final.finalAll.end}}万元</span>
                </p>
            </el-form-item>
            <el-form-item label="其他：">
                <el-checkbox v-model="final.otherFile.flag">无</el-checkbox>
                <div v-if="!final.otherFile.flag">
                    <div v-for="(item,index) in final.otherFile.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                        <el-input  v-if="edit" v-model="item.name" placeholder="" style="margin-right:1vw;"></el-input>
                        <el-input  v-else   v-model="item.name" placeholder="" style="margin-right:1vw;" disabled></el-input>
                        <el-upload
                            class="upload-demo len100"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess2"
                            :on-remove="handleDel2"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                        </el-upload>
                        <!-- <el-button v-if="!edit" size="small" type="primary">暂无</el-button> -->
                        <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddOtherFile" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit" v-show="delIndex3==index" class="el-icon-delete ctl" @click="delOtherFile(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item v-if="edit">
                <el-button type="primary" @click="onFinalSubmit">保存</el-button>
                <el-button>返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'
export default {
    data(){
        return{
            id:"",
            groupId:'',
            agreeName:'',
            uploadUrl:myHttp.uploadFile, //上传地址
            uploadHead:{
                accessToken: util.session.get('token')
            },
            form:{},
            final:{  //
                firstAccountinfo:{ //初审决算价款及报告
                    flag:false,
                    list:[
                        {index:1,start:'',startTime:'',end:'',entTime:'',files:[]},
                    ],
                },
                firstAll:{
                    start:0,
                    end:0
                },
                finalAccountinfo:{
                    flag:false,
                    list:[
                        {index:1,start:'',startTime:'',end:'',entTime:'',files:[]},
                    ],
                },
                finalAll:{
                    start:0,
                    end:0
                },
                otherFile:{
                    flag:false,
                    list:[
                        {name:'',files:[],index:1,} //index 用于区分list
                    ],
                },
            },
            delIndex:'-1',
            delIndex1:'-1',
            delIndex3:'-1',
            status:'',
            unitKind:'',
            edit:false,
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        var params = this.$route.params
        util.session.set('contractId',params.id)
        this.id = params.id
        this.status = params.status
        this.getInfo()
        this.edit = util.session.get('principalId')== util.session.get('user').id?true:false
        console.log(this.edit)
    },
    methods:{
        //获取合同信息
        getInfo(){
            var that = this
            myHttp.getContractById({
                id:this.id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.proContract
                    that.agreeName = data.name
                    that.unitKind = data.unitKind
                    that.getData()
                }
            })
        },
        //获取阶段信息
        getData(){
            var that = this
            myHttp.getContractStageByProjectId({
                contractId:this.id,
                unitKind:this.unitKind,
                status:this.status,
                flag:'0'
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    var data = resp.data.data.object
                    if(data){
                        for(var item in that.final){
                            if(data[item] && (data[item].indexOf('{')>-1 || data[item].indexOf('[')>-1)){
                                var str = JSON.parse(data[item])
                                for(var k in that.final[item]){
                                    if(str[k]){
                                        if(k=='list' && str[k].length==0){
                                            
                                        }else{
                                            that.final[item][k] = str[k]
                                        }
                                    }
                                }
                            }else if(data[item]){
                                that.final[item] = data[item]
                            }
                        }
                        that.setFirstTotal()
                        that.setFinalTotal()
                    }
                }
            })
        },
        //初审决算价款及报告
        handleSuccess(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.firstAccountinfo.list.length;i++){
                    if(this.final.firstAccountinfo.list[i].index==other){
                        this.final.firstAccountinfo.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel(file,fileList){
            for(var i=0;i<this.final.firstAccountinfo.list.length;i++){
                if(this.final.firstAccountinfo.list[i].index==file.index){
                    for(var j=0;j<this.final.firstAccountinfo.list[i].files.length;j++){
                        this.final.firstAccountinfo.list[i].files.splice(j,1)
                    }
                }
            }
        },
        //展示文件
        showFile(file){
            window.open(base.httpCtx+file.baseUrl)
        },
        //添加初审决算价款及报告
        toFirstAccount(){
            var length = this.final.firstAccountinfo.list.length
            var ind = this.final.firstAccountinfo.list[length-1].index
            var obj = {
                start:'',startTime:'',end:'',entTime:'',files:[],index:parseInt(ind)+1
            }
            this.final.firstAccountinfo.list.push(obj)
        },
        delFirstAccount(index){
            this.final.firstAccountinfo.list.splice(index,1)
            if(this.final.firstAccountinfo.list.length==0){
                var obj = {
                    index:1,start:'',startTime:'',end:'',entTime:'',files:[]
                }
                this.final.firstAccountinfo.list.push(obj)
            }
        },
        //终审决算价款及报告
        handleSuccess1(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.finalAccountinfo.list.length;i++){
                    if(this.final.finalAccountinfo.list[i].index==other){
                        this.final.finalAccountinfo.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel1(file,fileList){
            for(var i=0;i<this.final.finalAccountinfo.list.length;i++){
                if(this.final.finalAccountinfo.list[i].index==file.index){
                    for(var j=0;j<this.final.finalAccountinfo.list[i].files.length;j++){
                        this.final.finalAccountinfo.list[i].files.splice(j,1)
                    }
                }
            }
        },
        //添加终审决算价款及报告
        toFinalAccount(){
            var length = this.final.firstAccountinfo.list.length
            var ind = this.final.firstAccountinfo.list[length-1].index
            var obj = {
                start:'',startTime:'',end:'',entTime:'',files:[],index:parseInt(ind)+1
            }
            this.final.firstAccountinfo.list.push(obj)
        },
        delFinalAccount(index){
            this.final.firstAccountinfo.list.splice(index,1)
            if(this.final.firstAccountinfo.list.length==0){
                var obj = {
                    index:1,start:'',startTime:'',end:'',entTime:'',files:[]
                }
                this.final.firstAccountinfo.list.push(obj)
            }
        },
        //其他
        handleSuccess2(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.otherFile.list.length;i++){
                    if(this.final.otherFile.list[i].index==other){
                        this.final.otherFile.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel2(file,fileList){
            for(var i=0;i<this.final.otherFile.list.length;i++){
                if(this.final.otherFile.list[i].index==file.index){
                    for(var j=0;j<this.final.otherFile.list[i].files.length;j++){
                        this.final.otherFile.list[i].files.splice(j,1)
                    }
                }
            }
        },
        //其他
        toAddOtherFile(){
            var length = this.final.otherFile.list.length
            var ind = this.final.otherFile.list[length-1].index
            var obj = {
                name:'',files:[],index:parseInt(ind)+1
            }
            this.final.otherFile.list.push(obj)
        },
        delOtherFile(index){
            this.final.otherFile.list.splice(index,1)
            if(this.final.otherFile.list.length==0){
                var obj = {
                    name:'',files:[],index:1
                }
                this.final.otherFile.list.push(obj)
            }
        },
        //计算初审
        setFirstTotal(){
            var startAll = 0
            var endAll = 0
            var list = this.final.firstAccountinfo.list
            
            for(var i=0;i<list.length;i++){
                list[i].start = list[i].start==''?0:list[i].start
                list[i].end = list[i].end==''?0:list[i].end
                startAll += parseFloat(list[i].start)
                endAll += parseFloat(list[i].end)
            }
            this.final.firstAll = {
                start:startAll,
                end:endAll
            }
            // console.log(this.final.firstAll)
        },
        //计算
        setFinalTotal(){
            var startAll = 0
            var endAll = 0
            var list = this.final.finalAccountinfo.list
            // console.log(list)
            for(var i=0;i<list.length;i++){
                list[i].start = list[i].start==''?0:list[i].start
                list[i].end = list[i].end==''?0:list[i].end
                startAll += parseFloat(list[i].start)
                endAll += parseFloat(list[i].end)
            }
            this.final.finalAll = {
                start:startAll,
                end:endAll
            }
            // console.log(this.final.finalAll)
        },

        //解析list数据
        filterNull(data){
            var listNull = false
            for(var obj in data[0]){
                if(obj!='index'){
                    if(typeof data[0][obj]=='string' && data[0][obj]!=''){
                        listNull = true
                    }else if(Array.isArray(data[0][obj]) && data[0][obj].length>0){
                        listNull = true
                    }
                }
            }
            if(!listNull){
                data = []
            }
            return data
        },
        //提交
        onFinalSubmit(){
            var data = JSON.parse(JSON.stringify(this.final)) //this.final
            delete data['firstAll']
            delete data['finalAll']
            var columnName = ''
            for(var item in data){
                // if(data[item].list && data[item].list.length==1){
                //     if(data[item].list[0].start=='' && data[item].list[0].startTime=='' && data[item].list[0].end=='' && data[item].list[0].entTime=='' && data[item].list[0].files.length==0){
                //         data[item].list = []
                //     }
                // }
                for(var obj in data[item]){
                    if(obj=='list' && data[item][obj].length==1){
                        data[item][obj]=this.filterNull(data[item][obj])
                    }else if(obj!='flag' && obj!='list'){
                        if(data[item][obj]==''){
                            delete data[item][obj]
                        }
                    }
                }
                if(!data[item].flag){
                    columnName = columnName==''?item:columnName+','+item
                }
            }
            data['contractId'] = this.id
            var opt = {
                contractId:this.id,
                unitKind:this.unitKind,
                status:this.status,
                flag:'0',
                entity:JSON.stringify(data),
                updateBy:util.session.get('user').id,
                columnName:columnName,
                type:5
            }
            var that = this
            myHttp.createOrupdate(opt).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    that.$store.commit('setRefrshAgree',true)
                    that.$message.success('保存成功');
                }else{
                    that.$message.error(resp.msg);
                }
            })
        },

    }
}
</script>

<style scoped>
    .bid-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
</style>

<style>
    .bid-box .el-form-item__content{
        text-align: left;
    }
    .bid-box i.ctl{
        height:40px;
        line-height: 40px;
        margin-left: 0.5vw;
    }
    .bid-box .len100 .el-upload-list__item{
        width: 100%;
    }
    .bid-box .el-form-item__label{
        font-size: 14px;
        font-weight: bold;
        color: #000;
    }
    .bid-box .el-input__prefix{
        height: 40px;
    }
    /* .bid-box .el-upload-list__item-status-label{
        height: 40px;
        line-height: 40px;
    } */
</style>